import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  ${common.gql.display.link.fragments.link.DOC}
  fragment FragmentMosaicUiNavigateActionRendering on MosaicUiNavigateActionRendering {
    link {
      ...FragmentLink
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicUiNavigateActionRenderingFragment,
  ents.core.mosaic.Action.Rendering<ents.core.mosaic.Action.Operation.UiNavigate>
>({
  operation: () => ents.core.mosaic.Action.Operation.UiNavigate,
  payload: {
    usingFullInput: graphql.transformers.OUT.validate(
      graphql.transformers.OUT.select<
        graphql.schema.FragmentMosaicUiNavigateActionRenderingFragment,
        | ents.core.mosaic.Action.Payload<ents.core.mosaic.Action.Operation.UiNavigate>
        | undefined,
        'link'
      >(
        'link',
        common.gql.display.link.fragments.link.TRANSFORMER_FOR_REQUIRED_LINK,
      ),
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
  },
})
